import { Reveal, Eyebrow } from "@/components/Reveal";
import { useLang } from "@/lib/i18n";

export const Process = () => {
  const { t } = useLang();
  return (
  <section id="process" data-testid="process-section" className="py-24 md:py-32 bg-surface">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <Eyebrow>{t.process.eyebrow}</Eyebrow>
        <h2 className="text-3xl md:text-4xl tracking-tight font-bold text-[#F4F6F8] max-w-xl mb-14">
          {t.process.title}
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {t.process.list.map((step, i) => (
          <Reveal key={i} delay={(i % 3) * 0.08}>
            <div
              data-testid={`process-step-${i + 1}`}
              className="group relative bg-midnight border border-[#1E293B] p-8 pt-12 h-full overflow-hidden hover:border-gold/50 transition-[border-color] duration-300"
            >
              <span className="absolute -top-3 right-4 font-display font-black text-7xl text-white/5 group-hover:text-gold/10 transition-colors duration-300 select-none">
                {String(i + 1).padStart(2, "0")}
              </span>
              <p className="text-xs uppercase tracking-[0.25em] text-gold mb-3">{t.process.step} {i + 1}</p>
              <h3 className="text-lg font-semibold text-[#F4F6F8] mb-3">{step.title}</h3>
              <p className="text-sm text-[#94A3B8] leading-relaxed">{step.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
  );
};
